import { render, staticRenderFns } from "./CGVPreConsultForm.vue?vue&type=template&id=57c4424a&scoped=true"
import script from "./CGVPreConsultForm.vue?vue&type=script&lang=js"
export * from "./CGVPreConsultForm.vue?vue&type=script&lang=js"
import style0 from "./CGVPreConsultForm.vue?vue&type=style&index=0&id=57c4424a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4424a",
  null
  
)

export default component.exports